import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactDatePicker, {ReactDatePickerProps} from 'react-datepicker';
import {StyledTextbox} from '@nib-components/textbox';
import customStyles from './style';
import {breakpoint} from '@nib/layout';
import {CalendarSystemIcon} from '@nib/icons';
import MaskedInput from 'react-text-mask';

const StylesheetWrapper = styled.div`
  ${customStyles};
  touch-action: manipulation;
  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }
`;
StylesheetWrapper.displayName = 'StylesheetWrapper';

const Relative = styled.div`
  position: relative;
`;

export const ShowAtSm = styled.div`
  ${breakpoint('xs')`
    display: none;
  `}
  ${breakpoint('sm')`
    display: block;
  `}
`;

export const HideAtSm = styled.div`
  ${breakpoint('xs')`
    display: block;
  `}
  ${breakpoint('sm')`
    display: none;
  `}
`;

export const CalendarIcon = styled(CalendarSystemIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
  pointer-events: none;
`;

const MaskedDateInput = React.forwardRef<HTMLInputElement, DatePickerProps>((props: any, ref) => {
  const mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  return <MaskedInput guide={false} mask={mask} ref={ref} {...props} render={(ref, props) => <StyledTextbox ref={ref} {...props} inputMode="numeric" />} />;
});

export interface DatePickerProps extends ReactDatePickerProps {
  dateFormat?: string | string[];
  hasMask?: boolean;
  [key: string]: unknown;
}

//The hide and show code below is here to stop the keyboard input for mobile
//untill we add auto date masking and then we can use the numeric keyboard without issues
export const CalendarTextbox: React.FC<DatePickerProps> = React.forwardRef<HTMLInputElement, DatePickerProps>((props, ref) => (
  <Relative>
    <HideAtSm>
      <StyledTextbox ref={ref} {...props} readOnly="readonly" />
    </HideAtSm>
    <ShowAtSm>{props.hasMask ? <MaskedDateInput ref={ref} {...props} /> : <StyledTextbox ref={ref} {...props} />}</ShowAtSm>
    {!props.validated && <CalendarIcon size={props.isCompact ? 20 : 'sm'} />}
  </Relative>
));

const CustomInput = React.forwardRef<HTMLInputElement, DatePickerProps>((props, ref) => <CalendarTextbox ref={ref} {...props} />);

const DatePicker: React.FC<DatePickerProps> = React.forwardRef<any, DatePickerProps>((props, ref) => (
  <StylesheetWrapper>
    <ReactDatePicker ref={ref} customInput={<CustomInput {...props} />} {...props} />
  </StylesheetWrapper>
));

DatePicker.propTypes = {
  dateFormat: PropTypes.string,
  hasMask: PropTypes.bool
};

DatePicker.defaultProps = {
  dateFormat: 'dd/MM/yyyy',
  hasMask: false
};

export default DatePicker;
